import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import image from "../../assets/images/dummy_pic.jpeg";
import { BaseURL, uniqueToken } from '../../api/DataApis';
import axios from 'axios';
import "./Meter.css";
import "../Users/User.css"

const View = () => {
  const [MeterViewData, setMeterViewData] = useState({});
  let location = useLocation();
  let meterviewData = location?.state?.MeterViewData;
  
  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/user/meter-transaction/${meterviewData?.meterTransactions?._id}`;

    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });

      if (res && res.data && res.data.data && res.data.data.length > 0) {
        const fetchedMeterTransactions = res.data.data[0]?.meterTransactions;
        setMeterViewData(fetchedMeterTransactions);
      } else {
        console.error("No meter transaction data found");
      }
    } catch (error) {
      console.error("Error fetching meter transaction data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <h1 className="page-title"></h1>
            <div id="printablediv">
              <section className="panel">
                <div className="profile-header d-flex justify-content-center align-items-center">
                  <img src={image} alt="Profile" className="profile-image" />
                  <div className="profile-info ml-3">
                    <h2>{meterviewData?.name}</h2>
                    <p className="text-muted">Class: {meterviewData?.class}</p>
                  </div>
                </div>

                <div className="panel-body profile-view-dis">
                  <h3>Personal Information</h3>
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>Register No:</strong> {meterviewData?.registerNo}</p>
                      <p><strong>Gender:</strong> {meterviewData?.gender}</p>
                      <p><strong>Religion:</strong> {meterviewData?.religion}</p>
                      <p><strong>Phone:</strong> {meterviewData?.phone}</p>
                      <p><strong>Username:</strong> {meterviewData?.username}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Date of Birth:</strong> {meterviewData?.dob}</p>
                      <p><strong>Email:</strong> {meterviewData?.email}</p>
                      <p><strong>Address:</strong> {meterviewData?.address}</p>
                      <p><strong>Country:</strong> {meterviewData?.country}</p>
                    </div>
                  </div>

               

                  <h3>Meter Transaction Details</h3>
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>Meter Start Date:</strong> {meterviewData?.meterTransactions?.meterStartDate}</p>
                      <p><strong>Meter Stop Date:</strong> {meterviewData?.meterTransactions?.meterStopDate}</p>
                      <p><strong>Meter Start:</strong> {meterviewData?.meterTransactions?.meterStart}</p>
                      <p><strong>Meter Difference:</strong> {meterviewData?.meterTransactions?.meterDiff}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>Created Date:</strong> {MeterViewData?.createdAt}</p>
                      <p><strong>Meter Stop:</strong> {MeterViewData?.meterStop}</p>
                      <p><strong>Status:</strong> {meterviewData?.meterTransactions?.status}</p>
                      <p><strong>Used Amount:</strong> {meterviewData?.meterTransactions?.usedAmount}</p>
                      <p><strong>Wallet Amount:</strong> {meterviewData?.meterTransactions?.walletAmount}</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
